import React, { useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { normalizePhone, deNormalizePhone } from '../../utils/functions/tools/normalizePhone';
import ClientNav from '../../components/clientNav';
import { getClient } from '../../utils/functions/api/getClient';
import ClientContacts from './clientContacts';
import ClientNotes from './clientNotes';
import ClientSettings from './clientSettings';
import ClientDetails from './clientProfile';
import ClientSummary from './clientDashboard';
import { Breadcrumb, Button, BreadcrumbItem, Tile, Tag, Link, OverflowMenuItem, OverflowMenu } from 'carbon-components-react'
import Toast from '../../components/Notification/Toast'
import { getClientAddresses } from '../../utils/functions/api/getClientAddresses';
import { getClientPhoneNumbers } from '../../utils/functions/api/getClientPhoneNumbers';
import { getClientEmailAddresses } from '../../utils/functions/api/getClientEmailAddresses';
import AuthContext from '../../context/AuthContext'

const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const ClientShell = ({ match }) => {

    let { authTokens } = useContext(AuthContext)

    const [list, setList] = useState([]);
    let toastProperties = null;

    //assigning location variable
    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");

    // Variables for modals and toasts
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [editContactID, setEditContactID] = useState(false);

    // Variables for noteSeaarch
    let [client, setClient] = useState(null)

    // Other Variables
    let profileId = match.params.id
    let [tabActive, setTabActive] = useState(true)
    let [page, setPage] = useState(null)
    let [contacts, setContacts] = useState([])
    let [clientAddress, setClientAddress] = useState(null)
    let [clientAddresses, setClientAddresses] = useState(null)
    let [clientPhoneNumbers, setClientPhoneNumbers] = useState(null)
    let [clientEmailAddresses, setClientEmailAddresses] = useState(null)
    let [clientMailingAddress, setClientMailingAddress] = useState(null)
    let [clientBillingAddress, setClientBillingAddress] = useState(null)
    let [clientSettings, setClientSettings] = useState(null)
    let [currencies, setCurrencies] = useState(null)
    let [currencyCode, setCurrencyCode] = useState(null)
    let [countries, setCountries] = useState(null)
    let [clientCountry, setClientCountry] = useState(null)

    useEffect(() => {
        getClient(profileId, setClient, setClientAddress, setClientMailingAddress, setClientBillingAddress, API_URL, authTokens, setClientCountry)
        getClientAddresses(profileId, setClientAddresses, API_URL, authTokens)
        getClientPhoneNumbers(profileId, setClientPhoneNumbers, API_URL, authTokens)
        getClientEmailAddresses(profileId, setClientEmailAddresses, API_URL, authTokens)
        getContacts()
        getClientSettings()
        getCurrencies()
        getCountries()
        document.title = "Client Profile | WillowBMS"
        setPage(splitLocation[2])
    }, [profileId, editContactID])

    useEffect(() => {
        setPage(splitLocation[2])
    })

    let getCurrencies = async () => {
        let response = await fetch(`${API_URL}/system/financial/currencies/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setCurrencies(data)
    }

    let getCountries = async () => {
        let response = await fetch(`${API_URL}/system/referencedata/geographical/countries/`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setCountries(data)
    }

    let getCurrencyInfo = async (currency) => {
        let response = await fetch(`${API_URL}/system/financial/currency/${currency}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setCurrencyCode(data)
    }

    let editClient = async (values) => {
        values.preventDefault()

        // Update Primary Contacts
        if (client?.primary != values.target.primary.value) {
            // Fetch and Update Old Primary Contact
            if (client?.primary != null) {
                let responseOldContact = await fetch(`${API_URL}/client/contact/view/${client?.primary}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + authTokens?.access
                    }
                })
                let dataOldContact = await responseOldContact.json()
                let responseOld = await fetch(`${API_URL}/client/contact/manage/edit/${client?.primary}/`, {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + authTokens?.access
                    },
                    body: JSON.stringify({
                        'id': client?.primary,
                        'first_name': dataOldContact.first_name,
                        'last_name': dataOldContact.last_name,
                        'email': dataOldContact.email,
                        'is_primary': false,
                        'is_active': dataOldContact.is_active,
                    })
                })
            }
        }

        // Fetch and Update New Primary Contact
        let responseNewContact = await fetch(`${API_URL}/client/contact/view/${values.target.primary.value}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let dataNewContact = await responseNewContact.json()
        let responseNew = await fetch(`${API_URL}/client/contact/manage/edit/${values.target.primary.value}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'id': client?.primary,
                'first_name': dataNewContact.first_name,
                'last_name': dataNewContact.last_name,
                'email': dataNewContact.email,
                'is_primary': true,
                'is_active': dataNewContact.is_active,
            })
        })

        let response = await fetch(`${API_URL}/client/profile/manage/edit/${profileId}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'id': profileId,
                'company': values.target.company.value,
                'phoneNumber': deNormalizePhone(client?.phoneNumber),
                'status': client?.status,
                'email': client?.email,
                'is_active': client?.is_active,
                'primary': values.target.primary.value
            })
        })

        if (response.status === 200) {
            showToast("success", "Success", "Client details have been updated.")
            getContacts()
            getClient(profileId, setClient, setClientAddress, setClientMailingAddress, setClientBillingAddress, API_URL, authTokens, setClientCountry)
        } else {
            showToast("error", "Error", "Unable to update client details.")
        }
    }

    let clientStatusToggle = async () => {
        var set
        var status

        // Set new status
        if (client.is_active == false) {
            set = true
            status = "Active"
        } else {
            set = false
            status = "Inactive"
        }

        let response = await fetch(`${API_URL}/client/profile/manage/edit/${profileId}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens.access
            },
            body: JSON.stringify({
                'id': profileId,
                'company': client.company,
                'phoneNumber': deNormalizePhone(client.phoneNumber),
                'status': status,
                'email': client.email,
                'is_active': set,
                'primary': client.primary
            })
        })

        if (response.status === 200) {
            getClient(profileId, setClient, setClientAddress, setClientMailingAddress, setClientBillingAddress, API_URL, authTokens, setClientCountry)
            showToast("success", "Success", "Client status has been updated.")
        } else {
            showToast("error", "Error", "Unable to update client status.")
        }
    }

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    let editClientAddress = async (values) => {
        let response = await fetch(`${API_URL}/client/profile/manage/edit/address/${profileId}/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'id': clientAddress.map((address) => address.id).toString(),
                'address1': values.address1.toString(),
                'address2': values.address2.toString(),
                'city': values.city.toString(),
                'province': values.province.toString(),
                'country': values.country.toString(),
                'postalcode': values.postalcode.toString(),
                'type': '1',
                'client': profileId
            })
        })

        if (response.status === 200) {
            editClientAddressSuccess('topRight')
            getClient(profileId, setClient, setClientAddress, setClientMailingAddress, setClientBillingAddress, API_URL, authTokens, setClientCountry)
        } else {
            editClientAddressError('topRight')
        }
    }

    let editClientMailingAddress = async (values) => {
        if (clientMailingAddress.map((address) => address.id).length === 0) {
            let response = await fetch(`${API_URL}/client/profile/manage/edit/address/${profileId}/`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + authTokens?.access
                },
                body: JSON.stringify({
                    'id': clientMailingAddress.map((address) => address.id).toString(),
                    'address1': values.mailingddress1.toString(),
                    'address2': values.mailingddress2.toString(),
                    'city': values.mailingCity.toString(),
                    'province': values.mailingProvince.toString(),
                    'country': values.mailingCountry.toString(),
                    'postalcode': values.mailingPostalcode.toString(),
                    'type': '2',
                    'client': profileId
                })
            })

            if (response.status === 200) {
                editClientAddressSuccess('topRight')
                getClient(profileId, setClient, setClientAddress, setClientMailingAddress, setClientBillingAddress, API_URL, authTokens, setClientCountry)
            } else {
                editClientAddressError('topRight')
            }
        } else {
            let response = await fetch(`${API_URL}/client/profile/manage/edit/address/${profileId}/`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + authTokens?.access
                },
                body: JSON.stringify({
                    'id': clientMailingAddress.map((address) => address.id).toString(),
                    'address1': values.mailingddress1.toString(),
                    'address2': values.mailingddress2.toString(),
                    'city': values.mailingCity.toString(),
                    'province': values.mailingProvince.toString(),
                    'country': values.mailingCountry.toString(),
                    'postalcode': values.mailingPostalcode.toString(),
                    'type': '2',
                    'client': profileId
                })
            })

            if (response.status === 200) {
                editClientAddressSuccess('topRight')
                getClient(profileId, setClient, setClientAddress, setClientMailingAddress, setClientBillingAddress, API_URL, authTokens, setClientCountry)
            } else {
                editClientAddressError('topRight')
            }
        }
    }

    const editClientAddressSuccess = placement => {

    };

    const editClientAddressError = placement => {

    };

    let deleteAddress = async (addressID) => {
        let response = await fetch(`${API_URL}/client/profile/address/delete/${addressID}/`, {
            method: 'DELETE',
            'headers': {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })

        if (response.status === 200) {
            deleteAddressSuccess('topRight')
            getClient(profileId, setClient, setClientAddress, setClientMailingAddress, setClientBillingAddress, API_URL, authTokens, setClientCountry)
        } else {
            deleteAddressError('topRight')
        }
    }

    const deleteAddressSuccess = placement => {

    };

    const deleteAddressError = placement => {

    };

    let getClientSettings = async () => {
        if (profileId === 'new') return

        let response = await fetch(`${API_URL}/client/settings/view/${profileId}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setClientSettings(data)
        getCurrencyInfo(data.currency)
    }

    let getContacts = async () => {
        let response = await fetch(`${API_URL}/client/contacts/view/${profileId}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setContacts(data)
    }

    const validateMessages = {
        required: 'Field is required',
        types: {
            email: 'Please enter a valid email',
            number: 'Not a valid number',
        },
    };

    return (
        <div className="bms-page">
            {client &&
                <>
                    <Toast toastList={list} />
                    <div className="mb-2">
                        <Breadcrumb>
                            <BreadcrumbItem href="/clients">Clients</BreadcrumbItem>
                            <BreadcrumbItem href={`/client/dashboard/${client.id}`}>{client.company}</BreadcrumbItem>
                            <span>Dashboard</span>
                        </Breadcrumb>
                    </div>
                    <div>
                        <div className="w-full summary-header">
                            <Tile><strong className="d-flex">#{client.id} - {client.company}</strong></Tile>
                            <Tile light={true} className="w-full d-flex" style={{ minHeight: 0 }}>
                                <div className="col-6">
                                    <strong className="lh-27 d-flex">Summary</strong>
                                </div>
                                <div className="col-6 d-flex">
                                    <div className="ml-auto d-flex">
                                        {client.is_active === true ? <Tag className="bx--tag--green mr-2">Active</Tag> : <Tag className="bx--tag--red mr-2">Inactive</Tag>}
                                        <OverflowMenu className="ml-auto">
                                            <OverflowMenuItem onClick={() => clientStatusToggle()} itemText={client.is_active === true ? "Deactivate Client" : "Activate Client"} />
                                        </OverflowMenu>
                                    </div>
                                </div>
                            </Tile>
                        </div>
                        <div className="summary-body">
                            <Tile light={true} className="row w-full d-flex flex-w">
                                <div className="col-12 col-md-4 p-05">
                                    <div className="mb-05">
                                        <strong>ID:</strong> <span className="">{client.id}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Company Name:</strong> <span className="">{client.company}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Primary Contact:</strong> <span className="">{client.clientContacts.map((clientContacts, index) => (<span key={index} className=''>{clientContacts.is_primary && clientContacts.first_name + ' ' + clientContacts.last_name + ' (' + clientContacts.position + ')'}</span>))}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Email Address:</strong> <span className=""><Link href={`mailto:${client.email}`}>{client.email}</Link></span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Phone Number:</strong> <span className=""><Link href={`tel:${client.phoneNumber}`} className="link-info">{normalizePhone(client.phoneNumber)}</Link></span>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4 p-05">
                                    <div className="mb-05">
                                        <strong>Address:</strong> <span className="">{clientAddress.map((address) => address.address1)}</span>
                                    </div>
                                    {clientAddress.map((address) => address.address2) != "" &&
                                        <div className="mb-05">
                                            <span className="pl-4">{clientAddress.map((address) => address.address2)}</span>
                                        </div>
                                    }
                                    <div className="mb-05">
                                        <span className="pl-4">{clientAddress.map((address) => address.city)}</span>, <span>{clientAddress.map((address) => address.province)}</span> <span>{clientAddress.map((address) => address.postalcode)}</span>
                                    </div>
                                    <div className="mb-05">
                                        <span className="pl-4">{clientCountry?.country != null ? clientCountry?.country : client.country}</span>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 p-05">
                                    <div className="mb-05">
                                        <strong>Account Type:</strong> <span className="">{clientSettings?.type}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Language:</strong> <span className="">{clientSettings?.language}</span>
                                    </div>
                                    <div className="mb-05">
                                        <strong>Customer Currency:</strong> <span className="">{currencyCode?.currencycode}</span>
                                    </div>
                                </div>
                            </Tile>
                        </div>
                        <div className="w-full summary-footer">
                            <Tile light={true} className="w-full d-flex" style={{ minHeight: 0 }}>
                                <div className="col-6">
                                    <span className="text-sm"><strong>Client Since: </strong>{client.dateSince}</span>
                                </div>
                                <div className="col-6 d-flex">

                                </div>
                            </Tile>
                        </div>
                    </div>

                    <div className="d-flex flex-w mt-1">
                        <ClientNav profileId={profileId} />

                        <div className="col-12 col-sm-12 col-md-9">
                            {page === "dashboard" ? <>
                                <ClientSummary contacts={contacts} editClient={editClient} />
                            </> :
                                page === "details" ? <>
                                    <ClientDetails setClientEmailAddresses={setClientEmailAddresses} clientEmailAddresses={clientEmailAddresses} getClientEmailAddresses={getClientEmailAddresses} getClientPhoneNumbers={getClientPhoneNumbers} clientPhoneNumbers={clientPhoneNumbers} setClientPhoneNumbers={setClientPhoneNumbers} setClientAddresses={setClientAddresses} setClient={setClient} getClientAddresses={getClientAddresses} setClientAddress={setClientAddress} setClientMailingAddress={setClientMailingAddress} setClientBillingAddress={setClientBillingAddress} setClientCountry={setClientCountry} getClient={getClient} showToast={showToast} profileId={profileId} deleteAddress={deleteAddress} countries={countries} clientMailingAddress={clientMailingAddress} editClientMailingAddress={editClientMailingAddress} editClientAddress={editClientAddress} clientAddresses={clientAddresses} client={client} contacts={contacts} editClient={editClient} authTokens={authTokens} API_URL={API_URL} />
                                </> :
                                    page === "contacts" ? <>
                                        <ClientContacts setClientBillingAddress={setClientBillingAddress} setClientMailingAddress={setClientMailingAddress} setClient={setClient} API_URL={API_URL} getClient={getClient} getContacts={getContacts} profileId={profileId} contacts={contacts} setCountries={setCountries} authTokens={authTokens} setCurrencies={setCurrencies} setCurrencyCode={setCurrencyCode} setClientAddress={setClientAddress} setClientSettings={setClientSettings} setClientCountry={setClientCountry} setContacts={setContacts} contacts={contacts} showToast={showToast} />
                                    </> :
                                        page === "notes" ? <>
                                            <ClientNotes setClient={setClient} API_URL={API_URL} getClient={getClient} getContacts={getContacts} profileId={profileId} contacts={contacts} setCountries={setCountries} authTokens={authTokens} setCurrencies={setCurrencies} setCurrencyCode={setCurrencyCode} setClientAddress={setClientAddress} setClientSettings={setClientSettings} setClientCountry={setClientCountry} setContacts={setContacts} contacts={contacts} showToast={showToast} />
                                        </> :
                                            page === "settings" ? <>
                                                <ClientSettings client={client} getClientSettings={getClientSettings} currencies={currencies} currencyCode={currencyCode} setClient={setClient} API_URL={API_URL} getClient={getClient} getContacts={getContacts} profileId={profileId} contacts={contacts} setCountries={setCountries} authTokens={authTokens} setCurrencies={setCurrencies} setCurrencyCode={setCurrencyCode} setClientAddress={setClientAddress} setClientSettings={setClientSettings} setClientCountry={setClientCountry} setContacts={setContacts} contacts={contacts} showToast={showToast} />
                                            </> : <>
                                                <Tile light={true} className="mt-2">
                                                    <h1 className="text-center">404 Not Found</h1>
                                                    <div className="text-center mt-1">
                                                        <Button href={`/client/dashboard/${profileId}`}>Go to Dashboard</Button>
                                                    </div>
                                                </Tile>
                                            </>}
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default ClientShell